import React from 'react';
import { useSelector } from 'react-redux';
import { Form, DatePicker } from 'ui/components';
import { formatDate } from 'utilities/common';
import cn from 'classnames';

const initialState = {
  airplane: '',
  code_smu: '',
  no_manifest: '',
  date: {
    default: new Date(),
    formatted: formatDate(new Date(), 'YYYY-MM-DD'),
  },
  date_time: '',
  etd: {
    default: new Date(),
    formatted: formatDate(new Date(), 'YYYY-MM-DD'),
  },
  etd_time: '',
};

export const FormAir = ({ onValueChange, initialValue, removePadding }) => {
  const StateForm = useSelector((state) => state?.Form);

  const [
    { airplane, code_smu, no_manifest, date, etd, date_time, etd_time },
    setState,
  ] = React.useState(initialState);

  React.useEffect(() => {
    const value = {
      airplane,
      code_smu,
      no_manifest,
      date,
      etd,
      date_time,
      etd_time,
    };
    onValueChange(value);
  }, [airplane, code_smu, no_manifest, date, etd, date_time, etd_time]);

  React.useEffect(() => {
    if (!initialValue) return;

    setState((prevState) => ({
      ...prevState,
      airplane: initialValue?.airplane,
      code_smu: initialValue?.code_smu,
      no_manifest: initialValue?.no_manifest,
      date: {
        default: new Date(initialValue?.date),
        formatted: formatDate(initialValue?.date, 'YYYY-MM-DD'),
      },
      date_time: formatDate(initialValue?.date, 'HH:mm'),
      etd: {
        default: new Date(initialValue?.etd),
        formatted: formatDate(initialValue?.etd, 'YYYY-MM-DD'),
      },
      etd_time: formatDate(initialValue?.etd, 'HH:mm'),
    }));
  }, [initialValue]);

  return (
    <div className={cn(removePadding ? 'p-0' : 'p-3', 'h-100')}>
      <div className="row">
        <div className="col-md-6">
          <Form.Input
            value={airplane}
            onChange={(e) =>
              setState((prevState) => ({
                ...prevState,
                airplane: e.target.value,
              }))
            }
            type="text"
            label="Airplane"
            error={StateForm?.errors['air_freight.airplane']}
          />
        </div>
        <div className="col-md-6">
          <Form.Input
            required
            value={code_smu}
            onChange={(e) =>
              setState((prevState) => ({
                ...prevState,
                code_smu: e.target.value,
              }))
            }
            type="text"
            label="Code SMU"
            error={StateForm?.errors['air_freight.code_smu']}
          />
        </div>
        <div className="col-md-6">
          <Form.Input
            value={no_manifest}
            onChange={(e) =>
              setState((prevState) => ({
                ...prevState,
                no_manifest: e.target.value,
              }))
            }
            type="text"
            label="No. Manifest"
            error={StateForm?.errors['air_freight.no_manifest']}
          />
        </div>

        <div className="col-md-12">
          <div className="row">
            <div className="col-md-8 col-7">
              <div className="mb-3">
                <label className="form-label fs-8">Tanggal Keberangkatan</label>
                <div
                  className={
                    StateForm?.errors['air_freight.etd']
                      ? 'border border-danger rounded'
                      : ''
                  }
                >
                  <DatePicker
                    type="normal"
                    value={date?.default || null}
                    format="dd/MM/yyyy"
                    onChange={(d) =>
                      setState((prevState) => ({
                        ...prevState,
                        date: {
                          default: d,
                          formatted: formatDate(d, 'YYYY-MM-DD'),
                        },
                      }))
                    }
                    isShowTrigger
                  />
                </div>
                {StateForm?.errors['air_freight.date'] && (
                  <div
                    className="invalid-feedback"
                    style={{ display: 'block' }}
                  >
                    {StateForm?.errors['air_freight.date']}
                  </div>
                )}
              </div>
            </div>
            <div className="col-md-4 col-5">
              <Form.Time
                label="Jam Keberangkatan"
                value={date_time}
                onChange={(e) =>
                  setState((prevState) => ({
                    ...prevState,
                    date_time: e,
                  }))
                }
                error={StateForm?.errors['air_freight.date']}
              />
            </div>
          </div>
        </div>

        <div className="col-md-12">
          <div className="row">
            <div className="col-md-8 col-7">
              <div className="mb-3">
                <label className="form-label fs-8">Tanggal Estimasi Tiba</label>
                <div
                  className={
                    StateForm?.errors['air_freight.etd']
                      ? 'border border-danger rounded'
                      : ''
                  }
                >
                  <DatePicker
                    type="normal"
                    value={etd?.default}
                    format="dd/MM/yyyy"
                    onChange={(d) =>
                      setState((prevState) => ({
                        ...prevState,
                        etd: {
                          default: d,
                          formatted: formatDate(d, 'YYYY-MM-DD'),
                        },
                      }))
                    }
                    isShowTrigger
                  />
                </div>
                {StateForm?.errors['air_freight.etd'] && (
                  <div
                    className="invalid-feedback"
                    style={{ display: 'block' }}
                  >
                    {StateForm?.errors['air_freight.etd']}
                  </div>
                )}
              </div>
            </div>
            <div className="col-md-4 col-5">
              <Form.Time
                label="Jam Estimasi Tiba"
                value={etd_time}
                onChange={(e) =>
                  setState((prevState) => ({
                    ...prevState,
                    etd_time: e,
                  }))
                }
                error={StateForm?.errors['air_freight.etd']}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
